import React, { createContext } from 'react';

import enUS from 'date-fns/locale/en-US';

const defaultDateLocale: Locale = enUS;

const DateLocaleContext = createContext<Locale>(defaultDateLocale);

type DateLocaleProviderProps = {
	locale: Locale;
	children: React.ReactNode;
};

/**
 * Supplies the date-fns locale used to format date labels. Products must render this
 * above any date picker, otherwise every label falls back to en-US.
 */
export const DateLocaleProvider = ({
	locale,
	children,
}: DateLocaleProviderProps): React.JSX.Element => (
	<DateLocaleContext.Provider value={locale}>{children}</DateLocaleContext.Provider>
);

export const useDateLocale = (): Locale => React.useContext(DateLocaleContext);
